// extracted by mini-css-extract-plugin
export var carrierIcon = "_z2-0";
export var carrierLogo = "_z2-1";
export var detailsSection = "_z2-2";